import { render, staticRenderFns } from "./RevenueChart.vue?vue&type=template&id=3b34d1e3&scoped=true"
import script from "./RevenueChart.vue?vue&type=script&lang=js"
export * from "./RevenueChart.vue?vue&type=script&lang=js"
import style0 from "./RevenueChart.vue?vue&type=style&index=0&id=3b34d1e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34d1e3",
  null
  
)

export default component.exports